import { get } from "./get";
export function set(obj, path, value) {
  var _ref = [path.slice(0, -1), path.slice(-1)[0]],
    parentPath = _ref[0],
    fieldName = _ref[1];
  if (fieldName) {
    var parent = get(obj, parentPath);
    // In case parent object is not present, create it
    if (parent === undefined || parent === null) {
      set(obj, parentPath, {});
      parent = get(obj, parentPath);
    }
    // We check it on types level: FieldType extracted from object by path
    parent[fieldName] = value;
  }
}